import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Tooltip, Typography } from '@mui/material'
import useTenant from '@/hooks/useTenant'
import { InfoOutlined } from '@mui/icons-material'

const AllergensInfo: React.FC = () => {
  const tenant = useTenant()
  const { t } = useTranslation()
  return (
    <Tooltip
      arrow
      placement="left"
      sx={{ cursor: 'help' }}
      title={t('allergens:info', { tenantName: tenant.name })}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <InfoOutlined color="action" fontSize="medium" />
        <Typography width="fit-content" variant="body2" color="action.main">
          {t('cc:haveAnAllergy')}
        </Typography>
      </Stack>
    </Tooltip>
  )
}

export default AllergensInfo
